/**
 * @internal
 */
import React, { forwardRef } from 'react';
import Row from '@polestar/component-warehouse-react/components/row/Row';
import { MainAxisAlignments } from '@polestar/component-warehouse-react/tokens/alignments/Alignments';
import styled from '@emotion/styled';
import { createCustomSpacing } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const TimestampNumber = forwardRef(({ value, ...props }, ref) => (React.createElement(StyledRow, { ...props, mainAxisAlignment: MainAxisAlignments.center, ref: ref }, value)));
TimestampNumber.displayName = 'TimestampNumber';
export default TimestampNumber;
const StyledRow = styled(Row) `
  min-width: ${createCustomSpacing(9 / 16)};
`;
